// project imports
import config from 'config';

// ===============================|| Constants ||=============================== //

export const AuthHeader = {
    'Content-Type': 'application/json',
    Authorization: 'Bearer ' + localStorage.getItem('token')
};

export const ApiUrl = config?.proxy;

export default AuthHeader;
